// extracted by mini-css-extract-plugin
export default {"errorBoundaryError":"errorBoundaryError_a6uf","errorBoundaryFallback":"errorBoundaryFallback_VBag"};